'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var render = function render(_ref) {
	var props = _ref.props;
	var alignment = props.alignment,
	    color = props.color,
	    fontFamily = props.fontFamily,
	    fontSize = props.fontSize,
	    fontStyle = props.fontStyle,
	    fontWeight = props.fontWeight,
	    marginBottom = props.marginBottom,
	    marginTop = props.marginTop,
	    paddingHorizontal = props.paddingHorizontal,
	    paddingVertical = props.paddingVertical,
	    styleClasses = props.styleClasses,
	    text = props.text;

	var styles = {
		'margin-top': marginTop,
		'margin-bottom': marginBottom,
		'padding-bottom': paddingVertical,
		'padding-top': paddingVertical,
		'padding-left': paddingHorizontal,
		'padding-right': paddingHorizontal,
		color: color,
		'font-family': fontFamily,
		'font-size': fontSize,
		'font-style': fontStyle,
		'font-weight': fontWeight,
		'text-align': alignment
	};

	var attributes = {
		innerHTML: text,
		style: !styleClasses.Paragraph && styles,
		'data-style-attr': 'Paragraph',
		class: styleClasses.Paragraph
	};

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)('p', attributes), props);
};

exports.default = { render: render };